
const digest = 'a6932175898370611f38a3ab6e5d5b99ef2be9ce29684d80df6ade2958605813';
const classes = {"invoicingDetails":"_invoicingDetails_8li5g_1","attachmentNumber":"_attachmentNumber_8li5g_11","invoices":"_invoices_8li5g_16","state":"_state_8li5g_22","sent":"_sent_8li5g_25","commission":"_commission_8li5g_29"};
const css = `._invoicingDetails_8li5g_1 {
  display: flex;
  flex-wrap: wrap;
  margin-top: 16px;
}
._invoicingDetails_8li5g_1 > * {
  margin-left: 16px;
  margin-bottom: 16px;
}

._attachmentNumber_8li5g_11 {
  color: #2867d9;
  text-decoration: underline;
}

._invoices_8li5g_16 {
  display: flex;
  flex-direction: column;
  gap: 5px;
}

._state_8li5g_22 {
  font-weight: 500;
}
._state_8li5g_22._sent_8li5g_25 {
  color: #f39a3a;
}

._commission_8li5g_29 {
  color: #619611;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  